<ng-template let-item let-index="index" let-first="first" let-last="last" #creditCardStmtTmplt
  [appControlTemplate]="'creditCardStmtTmplt'">

  <box class="credit-card-trx-item">
    <box class="trx-icon">
      <!-- <ng-container *ngIf="item.merchantId; else noPhoto">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container> -->
      <!-- <ng-template #noPhoto>
        {{ item.transactionDesc.charAt(0).toUpperCase() }}
      </ng-template> -->
      <ng-container>
        <img [src]="'./assets/images/trxicons/trx-icon.svg'">
      </ng-container>
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <ng-container *ngIf="commonService.isMobile()">
          <span class="date">{{ item.transactionDate | date : "dd/MM/yyyy" }}</span>
          <!-- <span class="title">{{ item.transactionDesc }}</span> -->
          <span class="description">{{ item.transactionDesc }}</span>
        </ng-container>

        <ng-container *ngIf="commonService.isDesktop()">
          <div class="sec-1-2">
            <!-- <span class="title">{{ item.transactionDesc }}</span> -->
            <span class="date">{{ item.transactionDate | date : "dd/MM/yyyy" }}</span>
          </div>
          <box class="desc">
            <box class="sec-2-1">
              <span class="description">{{ item.transactionDesc }}</span>
            </box>
            <box class="sec-2-2">
              <!-- <span class="date">{{ item.transactionDate | date : "dd/MM/yyyy" }}</span> -->
            </box>
          </box>
        </ng-container>
      </box>
      <box class="trx-secondary-info">
        <ng-container *ngIf="commonService.isMobile()">
          <span class="trx-tag"></span>
          <span class="amount" [ngClass]="{'debit': item.debitcreditflag == 'D'}">
            <span class="debit-sign">-</span>
            <span class="credit-sign">+</span>
            {{item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>PGK</em>
          </span>
        </ng-container>
        <ng-container *ngIf="commonService.isDesktop()">
          <span class="trx-tag"></span>
          <span class="amount" [ngClass]="{'debit': item.debitcreditflag == 'D'}">
            <span class="debit-sign">-</span>
            <span class="credit-sign">+</span>{{
            item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>PGK</em>
          </span>
        </ng-container>
      </box>
    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #recentTransactionsTmplt
  [appControlTemplate]="'recentTransactionsTmplt'">
  <box class="casa-transaction-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="(item.merchantId || item.transactionCat); else noPhoto">
        <img *ngIf="item.icon; else noPhoto" [ngClass]="{'merchant-img': item.merchantId}"
          [src]="'./assets/images/trxicons/'+item.icon">
      </ng-container>
      <ng-template #noPhoto>
        {{ item.transactionDescription?.charAt(0)?.toUpperCase() }}
      </ng-template>
    </box>
    <box class="trx-details">
        <ng-container *ngIf="commonService.isMobile()">
      <box class="rec-trx-primary-info">
          <span class="date">{{ item.transactionDate?.split(' ')?.[0] }}</span>
          <span class="title">{{ item.transactionDescription}}</span>
          <span class="balance">Balance: {{ item.transactionCurrency}}<em>
            {{item.runningBalance | currency : item.transactionCurrency : '' }}</em></span>
          </box>
           <span class="rec-trx-secondary-info">
            <!-- <span class="trx-tag">{{ item.transactionCat }}</span> -->
            <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
              <span class="debit-sign">-</span>
              <span class="credit-sign">+</span>
              {{item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
                }}</em>
            </span>
          </span>
        </ng-container>
        <ng-container *ngIf="commonService.isDesktop()">
      <box class="rec-trx-primary-info">
            <span class="date">{{ item.transactionDate?.split(' ')?.[0] }}</span>
            <span class="title">{{ item.transactionDescription}}</span>
    </box>

            <box class="rec-trx-secondary-info ">
                    <ng-container *ngIf="commonService.isMobile()">
                      <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
                        <span class="debit-sign">-</span>
                        <span class="credit-sign">+</span>
                        {{item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
                          }}</em>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="commonService.isDesktop()">

                      <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
                        <span class="debit-sign">-</span>
                        <span class="credit-sign">+</span>{{
                        item.transactionAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
                          }}</em>
                      </span>
                    </ng-container>
        <span class="balance">Balance: {{ item.transactionCurrency}}<em>
          {{item.runningBalance | currency : item.transactionCurrency : '' }}</em></span>

                    <!--OLD <span class="date">{{ item.transactionDate | date : "dd/MM/yyyy" }}</span> -->
                  </box>

        </ng-container>

    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #loanStmtTmplt
  [appControlTemplate]="'loanstmtTmplt'">

  <box class="casa-transaction-trx-item">
     <box class="trx-icon">
      <ng-container *ngIf="(item.merchantId || item.transactionCat); else noPhoto">
        <img  [ngClass]="{'merchant-img': item.merchantId}"
          [src]="'./assets/images/trxicons/'+item.icon">
      </ng-container>
      <ng-template #noPhoto>
        <i class="icon ico-secure-payment"></i>
      </ng-template>
    </box>
    <box class="trx-details">
        <ng-container *ngIf="commonService.isMobile()">
      <box class="rec-trx-primary-info">
          <span class="date">{{ item.transactionDate?.split(' ')?.[0] }}</span>
          <span class="title">{{ item.narration}}</span>
          <span class="balance">Balance: {{ item.transactionCurrency}}<em>
            {{item.runningBalance | currency : item.transactionCurrency : '' }}</em></span>
          </box>
           <span class="rec-trx-secondary-info">
            <!-- <span class="trx-tag">{{ item.transactionCat }}</span> -->
            <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
              <span class="debit-sign">-</span>
              <span class="credit-sign">+</span>
              {{item.debitAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
                }}</em>
            </span>
          </span>
        </ng-container>
        <ng-container *ngIf="commonService.isDesktop()">
      <box class="rec-trx-primary-info">
            <span class="date">{{ item.transactionDate?.split(' ')?.[0] }}</span>
            <span class="title">{{ item.narration}}</span>
    </box>

            <box class="rec-trx-secondary-info ">
                    <ng-container *ngIf="commonService.isMobile()">
                      <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
                        <span class="debit-sign">-</span>
                        <span class="credit-sign">+</span>
                        {{item.debitAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
                          }}</em>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="commonService.isDesktop()">

                      <span class="amount" [ngClass]="{'debit': item.dbcrFlag == 'D'}">
                        <span class="debit-sign">-</span>
                        <span class="credit-sign">+</span>{{
                        item.debitAmount | currency : item.transactionCurrency : '' }}&nbsp;<em>{{ item.transactionCurrency
                          }}</em>
                      </span>
                    </ng-container>
        <span class="balance">Balance: {{ item.transactionCurrency}}<em>
          {{item.runningBalance | currency : item.transactionCurrency : '' }}</em></span>

                    <!--OLD <span class="date">{{ item.transactionDate | date : "dd/MM/yyyy" }}</span> -->
                  </box>

        </ng-container>

    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #depositStmtTmplt
  [appControlTemplate]="'depositStmtTmplt'">
  <box class="deposit-detail">
    <box class="deposit-logo">
      <img src="./assets/images/icons/deposits.svg" alt="deposit" />
    </box>

    <box class="details">
      <box class="sec-1">
        <ng-container *ngIf="commonService.isMobile()">
          <!-- <div class="sec-1-1"> -->
          <span class="open-date">{{
            item?.openDate | date: "dd/MM/yyyy"
            }}</span>

          <span class="account-name">{{
            item?.depositNickname ? item.depositNickname : item?.accountTypeDesc
            }}</span>
          <!-- </div> -->
        </ng-container>
        <ng-container *ngIf="commonService.isDesktop()">
          <div class="sec-1-2">
            <span class="account-name">{{
              item?.depositNickname
              ? item.depositNickname
              : item?.accountTypeDesc
              }}</span>
            <span class="open-date">{{
              item?.openDate | date: "dd/MM/yyyy"
              }}</span>
          </div>
        </ng-container>
        <box class="months-returns">
          <span class="months">{{ item?.accountNumber }}</span>
          <span class="returns">{{ item?.interestRate }} % Return</span>
        </box>
      </box>
      <ng-container *ngIf="commonService.isDesktop()">
        <!-- <box class="sec-2 maturity-progress">
        <span class="fill" [style.width.%]="item?.depositState"> &nbsp; </span>
      </box> -->
      </ng-container>
      <ng-container *ngIf="commonService.isMobile()">
        <!-- <box class="sec-2 maturity-progress">
          <span class="fill" [style.width.%]="item?.depositState"> &nbsp; </span>
        </box> -->
      </ng-container>

      <box class="sec-3">
        <span>Deposit Amount <span class="amount">{{item?.depositAmount | currency : item?.currency : '' }} <span>{{item?.currency}}</span></span></span>
        <span>Maturity Amount <b><span class="amount">{{item?.maturityAmount | currency : item?.currency : ''}} <span>{{item?.currency}}</span></span></b> on
          {{item?.maturityDate | date : "dd/MM/yyyy"}}</span>
      </box>

    </box>

  </box>
</ng-template>

<ng-template #billerCategory [appControlTemplate]="'billerCategory'" let-item let-index="index" let-first="first"
  let-last="last">
  <div class="biller-category-wrapper">
    <img [src]="item.billerLogo" [alt]="item.title">
    <!-- <img  src="../../../assets/images/icons/broadband.svg" alt="img"> -->
    <span class="biller-category-title">{{item.description}}</span>
  </div>
</ng-template>

<ng-template #billerList [appControlTemplate]="'billerList'" let-item let-index="index" let-first="first"
  let-last="last">

  <div class="biller-item">
    <div class="biller-detail-item">
      <div class="biller-photo">
        <ng-container *ngIf="item?.servicetypes[0].icon; else noPhoto">
          <img *ngIf="item?.servicetypes[0].icon; else noPhoto"
            [src]="'./assets/images/bill-payment/'+ item?.servicetypes[0].icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <span *ngIf="item.name.split(' ').length == 1">{{
              item.name.substring(0, 1)
              }}</span>
            <span *ngIf="
                  item.name.split(' ').length > 1 &&
                  item.name.split(' ').length != 1
                  ">{{
              item.name.split(" ")[0]?.charAt(0) +
              (item.name.split(" ")[1]
              ? item.name.split(" ")[1]?.charAt(0)
              : "")
              }}</span>
          </div>
        </ng-template>
      </div>

      <div class="biller-details">
        <div class="biller-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #upcomingbillerList let-selectedData="selectedData" [appControlTemplate]="'upcomingbillerList'" let-item
  let-index="index" let-first="first" let-last="last">
  <div class="biller-item">
    <div class="biller-detail-item">
      <div class="biller-photo">
        <ng-container *ngIf="item?.serviceTypeId?.icon; else noPhoto">
          <img *ngIf="item?.serviceTypeId?.icon; else noPhoto"
            [src]="'./assets/images/bill-payment/'+ item?.serviceTypeId?.icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <span
              *ngIf="((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(' ').length == 1">{{
              ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.substring(0, 1)
              }}</span>
            <span *ngIf="
                        ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(' ').length > 1 &&
                        ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(' ').length != 1
                  ">{{
              ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(" ")[0]?.charAt(0) +
              (((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(" ")[1]
              ? ((item?.nickName) ? item?.nickName : item?.serviceTypeId?.description)?.split(" ")[1]?.charAt(0)
              : "")
              }}</span>
          </div>
        </ng-template>
      </div>

      <div class="biller-details">
        <div class="biller-date">{{ item?.upcomingbills?.dueDate? 'Due on '+ (item?.upcomingbills?.dueDate.split(' ')[0]
          | date :'dd MMM') : 'No Dues' }}</div>
        <div class="biller-name">{{item?.serviceTypeId?.description}}</div>
        <div class="biller-accountnumner">{{ item?.billerAccountNum }}</div>
      </div>

      <div class="biller-details amount-check-contaioner">
        <div class="check-icon-main" *ngIf="(item?.upcomingbills)">
          <span class="biller-icon" [ngClass]="
                ( selectedData | isRowSelected: index:'index')
                  ? 'biller-selected'
                  : 'biller-unselected'
              ">
            <span class="checkmark"></span>
          </span>


        </div>
        <div *ngIf="(item?.upcomingbills)" class="amount-main"> <span class="biller-amount">{{
            commonService.formatAmount(item.upcomingbills?.dueAmount)}}</span> <span class="currency">{{
            commonService.baseCurrency }}</span>
        </div>
        <!-- <div *ngIf="(item?.upcomingbills | json) == '{}'" class="amount-main"> <span class="biller-amount">No dues</span></div> -->

      </div>
    </div>
  </div>
</ng-template>


<ng-template let-item let-index="index" let-first="first" let-last="last" #paymentHistory
  [appControlTemplate]="'paymentHistory'">
  <box class="payment-history-trx-item">
    <box class="trx-icon">
      <div class="biller-photo">
        <ng-container *ngIf="item.icon; else noPhoto">
          <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/bill-payment/'+item.icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <ng-container *ngIf="item.description; else noName">
              <span *ngIf="item.description?.split(' ').length == 1">{{item.description?.substring(0, 1)}}
              </span>
              <span *ngIf="item.description?.split(' ').length > 1 && item.description?.split(' ').length != 1">
                {{item.description?.split(" ")[0]?.charAt(0) +(item.description?.split(" ")[1]?
                item.description?.split(" ")[1]?.charAt(0): "")}}
              </span>
            </ng-container>
            <ng-template #noName>
              <span> {{ item.description?item.description:'U' }}
              </span>
            </ng-template>

          </div>
        </ng-template>
      </div>
      <!-- {{ item.description?.charAt(0).toUpperCase() }} -->
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <span class="date">{{ item.paymentDate | date :'dd/MM/yyyy' }}</span>
        <span class="title">{{ item.description?item.description:'Unknown' }}</span>
        <span class="description">
          <ng-container *ngIf="item.status; else noStatus">
            <span *ngIf="item.status=='S'" class="success">Successful</span>
            <span *ngIf="item.status=='F'" class="fail">Declined</span>
          </ng-container>
          <ng-template #noStatus>
            <!-- <span class="initiated">Initiated</span> -->
          </ng-template>
        </span>
      </box>
      <box class="trx-secondary-info">
        <div class="arrow-right">
          <img src="./assets/images/icons/arrow-right.svg" alt="icon" />
        </div>
        <span class="payment-amount">
          <span class="amount">
            {{ commonService.formatAmount(item.paymentAmount) }}
          </span>
          <span class="currency">
            {{item.currency}}
          </span>
        </span>

      </box>
    </box>
  </box>
</ng-template>
<!-- scheduledBillList -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #scheduledBillList
  [appControlTemplate]="'scheduledBillList'">
  <box class="scheduled-bill-item">
    <box class="trx-icon">
      <div class="biller-photo">
        <ng-container *ngIf="item.icon; else noPhoto">
          <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/bill-payment/'+item.icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <ng-container *ngIf="item.description; else noName">
              <span *ngIf="item.description?.split(' ').length == 1">{{item.description?.substring(0, 1)}}
              </span>
              <span *ngIf="item.description?.split(' ').length > 1 && item.description?.split(' ').length != 1">
                {{item.description?.split(" ")[0]?.charAt(0) +(item.description?.split(" ")[1]?
                item.description?.split(" ")[1]?.charAt(0): "")}}
              </span>
            </ng-container>
            <ng-template #noName>
              <span> {{ item.description?item.description:'U' }}
              </span>
            </ng-template>

          </div>
        </ng-template>
      </div>
      <!-- {{ item.description?.charAt(0).toUpperCase() }} -->
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <span class="date">Due on {{ item.startDate | date :'dd MMM' }}</span>
        <!-- <span class="date">{{ item.nextPaymentDate | date :'dd/MM/yyyy' }}</span> -->
        <!-- <span class="date">{{ item.endDate | date :'dd/MM/yyyy' }}</span> -->
        <!-- <span class="title">{{ item.description?item.description:'Unknown' }}</span> -->
        <!-- <span class="description">
            <ng-container *ngIf="item.status; else noStatus">
            <span *ngIf="item.status=='S'"class="success" >Successful</span>
            <span *ngIf="item.status=='F'" class="fail">Declined</span>
          </ng-container>
            <ng-template #noStatus>
              <span class="initiated">Initiated</span>
            </ng-template>
          </span> -->
      </box>
      <box class="trx-secondary-info">
        <!-- <span class="trx-tag">{{ item.transactionCat }}</span> -->
        <span class="payment-amount">
          <span class="amount">
            {{ commonService.formatAmount(item.paymentAmount) }}
          </span>
          <span class="currency">
            {{item.currency}}
          </span>
        </span>

      </box>
    </box>
  </box>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #beneTypes [appControlTemplate]="'beneTypes'">
  <div class="bene-types-wrapper" clickable>
    <ng-container *ngIf="item.beneRequired==1">
      <div class="bene-types">
        <img class="bene-type-logo" [ngClass]="item.systemCode+'_img'"
          [src]="'./assets/images/transfers/'+item.icon+'.svg'">
        <span class="bene-type-title">{{item.name}}</span>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #newTransfersCategory
  [appControlTemplate]="'newTransfersCategory'">
  <div class="transfer-category-wrapper">

    <ng-container *ngIf="item.enabled == 1">
      <span class="transfer-category-title">{{item.name}}</span>
      <img class="transfer-category-logo" *ngIf="item.icon;" [src]="'./assets/images/transfers/'+item.icon+'.svg'">
    </ng-container>
  </div>
</ng-template>
<!-- recentTransferDisplyGridTmplt -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #recentTransferDisplyGridTmplt
  [appControlTemplate]="'recentTransferDisplyGridTmplt'">
  <box class="transfers-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="item.merchantId; else elseif11">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container>
      <ng-template #elseif11>
        <ng-container *ngIf="item.serviceCode == 'TRANINTBT' || item.serviceCode == 'PAYTOPAYID'; else elseif12">
          <img [src]="'./assets/images/transfers/Within Bank Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif12>
        <ng-container *ngIf="item.serviceCode == 'TRANSWIFT'; else elseif13">
          <img [src]="'./assets/images/transfers/international-transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif13>
        <ng-container *ngIf="item.serviceCode == 'TRANDOMESTIC'; else elseif14">
          <img [src]="'./assets/images/transfers/EFT Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif14>
        <ng-container *ngIf="item.serviceCode == 'TRANINTRACSEND'; else elseif15">
          <img [src]="'./assets/images/transfers/Send E-Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif15>
        <ng-container *ngIf="item.serviceCode == 'TRANINTRACREQUEST'; else elseif16">
          <img [src]="'./assets/images/transfers/Receive E-Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif16>
        <ng-container *ngIf="item.serviceCode == 'TRANINTERNATIONAL'; else elseif17">
          <img [src]="'./assets/images/transfers/international-transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif17>
        <ng-container *ngIf="item.serviceCode == 'TRANOAT'; else noPhoto">
          <img [src]="'./assets/images/transfers/Own Account Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #noPhoto>
        <img [src]="'./assets/images/icons/default-profile-pic.svg'">
        <!-- {{ item.serviceCode?.charAt(0).toUpperCase() }} -->
      </ng-template>
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">
        <span class="date">{{ item.createdOn | date :'dd/MM/YYYY' }}</span>
        <ng-container *ngIf="item.serviceCode != 'PAYTOPAYID'">
          <span class="title">{{ item.serviceCode=="TRANOAT"?"Own Account": item.beneName }}</span>
        </ng-container>
        <ng-container *ngIf="item.serviceCode == 'PAYTOPAYID'">
          <span class="title">{{ (item.beneName).substring(0,3)+ "*****"+(item.beneName).slice(-3) }}</span>
        </ng-container>
        <span class="description">{{ item.debitNarration }}</span>
        
        <!-- <span class="description">Credited to:{{item.creditAcc}}</span> -->
         <ng-container *ngIf="item.serviceCode != 'TRANINTERNATIONAL'">
        <span class="description">Ref# : {{item.paymentId.substring(item.paymentId.length-6) }}</span>
        </ng-container>
        <ng-container *ngIf="item.serviceCode == 'TRANINTERNATIONAL' && item.status == 'S'">
          <span class="description">Ref# : {{ item.externalRef.split('-')[4] }}</span>
        </ng-container>
        <ng-container *ngIf="item.serviceCode == 'TRANINTERNATIONAL' && item.status !== 'S'">
          <span class="description">Ref# : {{ item.paymentId.substring(item.paymentId.length-6) }}</span>
        </ng-container>
      </box>
      <box class="trx-secondary-info">
        <div class="status-paymenttype-container">
          <ng-container *ngIf="item.serviceCode == 'TRANINTBT'; else elseif1">
            <span class="trx-tag">WITHIN BANK</span>
          </ng-container>
          <ng-template #elseif1>
            <ng-container *ngIf="item.serviceCode == 'TRANSWIFT'; else elseif2">
              <span class="trx-tag">INTERNATIONAL</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif2>
            <ng-container *ngIf="item.serviceCode == 'TRANIFSC'; else elseif3">
              <span class="trx-tag">BANK TO BANK TRANSFER</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif3>
            <ng-container *ngIf="item.serviceCode == 'TRANINTRACSEND'; else elseif4">
              <span class="trx-tag">INTERAC SEND</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif4>
            <ng-container *ngIf="item.serviceCode == 'TRANINTRACREQUEST'; else elseif5">
              <span class="trx-tag">INTERAC REQUEST</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif5>
            <ng-container *ngIf="item.serviceCode == 'TRANDOMKATS' || item.serviceCode == 'TRANDOMESTIC'; else elseif6">
              <span class="trx-tag">DOMESTIC</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif6>
            <ng-container *ngIf="item.serviceCode == 'PAYTOPAYID'; else elseif7">
              <span class="trx-tag">PAY TO PAYID</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif7>
            <ng-container *ngIf="item.serviceCode == 'TRANOAT'; else elseif8">
              <span class="trx-tag">OWN ACCOUNT</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif8>
            <ng-container *ngIf="item.serviceCode == 'TRANINTERNATIONAL'; else else4">
              <span class="trx-tag">INTERNATIONAL</span>
            </ng-container>
          </ng-template>
          <!-- <span class="trx-tag trx-tag-status" [class.success] = "item.status === 'S'">{{item.status=='S'?'SUCCESS':'FAILED'}}</span> -->
          <span class="trx-tag trx-tag-status" [class.success] = "item.status === 'S'">{{item.status=='S' ? 'SUCCESS': item.status == 'P' ? 'PENDING' : 'FAILED'}}</span>
        </div>
        <span class="amount">
          <span class="debit-sign">-</span>{{
          item.paymentAmount | currency : item.paymentCurrency : '' }}
          &nbsp;<em>{{item.paymentCurrency }}</em>
        </span>
      </box>
    </box>
  </box>

</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #favTransferMiniDisplayGridTmplt
  [appControlTemplate]="'favTransferMiniDisplayGridTmplt'">
  <box *ngIf="!commonService.isDesktop()" class="fav-recent-transfers">
    <box class="prof-image">

      <ng-container *ngIf="item?.serviceCode == 'TRANOAT';else noOat">
        <img [src]="'./assets/images/icons/default-profile-pic.svg'">
      </ng-container>

      <ng-template #noOat>
        {{commonService.getNameInitial(item.transfers?.beneName)}}
      </ng-template>

    </box>
    <box class="fav-recent-transfer-info">
      <!-- <span class="fav-transfer-value">{{item.serviceCode}}</span> -->
      <ng-container *ngIf="item?.serviceCode == 'TRANINTBT'; else elseif1">
        <span class="fav-transfer-value">{{item?.transfers?.beneName}}</span>
      </ng-container>
      <ng-template #elseif1>
        <ng-container *ngIf="item.serviceCode == 'TRANSWIFT'; else elseif2">
          <span class="fav-transfer-value">{{item?.transfers?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif2>
        <ng-container *ngIf="item?.serviceCode == 'TRANIFSC'; else elseif3">
          <span class="fav-transfer-value">{{item?.transfers?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif3>
        <ng-container *ngIf="item?.serviceCode == 'TRANINTRACSEND'; else elseif4">
          <span class="fav-transfer-value">{{item?.transfers?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif4>
        <ng-container *ngIf="item?.serviceCode == 'TRANINTRACREQUEST'; else elseif5">
          <span class="fav-transfer-value">{{item?.transfers?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif5>
        <ng-container *ngIf="item?.serviceCode == 'TRANDOMESTIC'; else elseif6">
          <span class="fav-transfer-value">{{item?.transfers?.beneName}}</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif6>
        <ng-container *ngIf="item?.serviceCode == 'TRANOAT'; else elseif7">
          <span class="fav-transfer-value">Own Account</span>
        </ng-container>
      </ng-template>
      <ng-template #elseif7>
        <ng-container *ngIf="item?.serviceCode == 'TRANINTERNATIONAL'; else else4">
          <span class="fav-transfer-value">{{item?.transfers?.beneName}}</span>
        </ng-container>
      </ng-template>
      <span class="fav-transfer-amount amount">{{commonService.formatAmount(item?.paymentAmount)}}
        <span>{{item?.paymentCurrency}}</span></span>
    </box>
  </box>
  <box *ngIf="commonService.isDesktop()" class="transfers-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="item?.merchantId; else noPhoto">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container>
      <ng-template #noPhoto>
        <!-- <img  [src]="'./assets/images/icons/default-profile-pic.svg'"> -->
        <!-- {{ item.serviceCode?.charAt(0).toUpperCase() }} -->
        <ng-container *ngIf="item?.serviceCode == 'TRANOAT'; else noOat">
          <img [src]="'./assets/images/icons/default-profile-pic.svg'">
        </ng-container>

        <ng-template #noOat>
          {{commonService.getNameInitial(item.transfers?.beneName)}}
        </ng-template>
      </ng-template>
    </box>
    <box class="trx-details-with-repeat">
      <box class="trx-details">
        <box class="trx-primary-info">
          <span class="date">{{ item?.paymentDate | date : "dd/MM/yyyy" }}</span>
          <span class="title">{{ item?.serviceCode == 'TRANOAT'?'Own Account':item?.transfers?.beneName }}</span>
          <!-- <span class="description">Credited to:{{item.accountNumber}}</span> -->
          <!-- <span class="description">Ref:{{ item.debitAccount }}</span> -->
        </box>
        <box class="trx-secondary-info">
          <!-- <span class="trx-tag">{{ item.serviceCode }}</span> -->
          <ng-container *ngIf="item?.serviceCode == 'TRANINTBT'; else elseif1">
            <span class="trx-tag">Within Bank Transfer</span>
          </ng-container>
          <ng-template #elseif1>
            <ng-container *ngIf="item?.serviceCode == 'TRANSWIFT'; else elseif2">
              <span class="trx-tag">Swift Transfer</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif2>
            <ng-container *ngIf="item?.serviceCode == 'TRANSIFSC'; else elseif3">
              <span class="trx-tag">IFSC Transfer</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif3>
            <ng-container *ngIf="item?.serviceCode == 'TRANINTRACSEND'; else elseif4">
              <span class="trx-tag">Interac Send</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif4>
            <ng-container *ngIf="item?.serviceCode == 'TRANINTRACREQUEST'; else elseif5">
              <span class="trx-tag">Interac Request</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif5>
            <ng-container *ngIf="item?.serviceCode == 'TRANDOMESTIC'; else elseif6">
              <span class="trx-tag">Domestic Transfer</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif6>
            <ng-container *ngIf="item?.serviceCode == 'TRANOAT'; else elseif7">
              <span class="trx-tag">Own Account</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif7>
            <ng-container *ngIf="item?.serviceCode == 'TRANINTERNATIONAL'; else  else4">
              <span class="trx-tag">International Transfer</span>
            </ng-container>
          </ng-template>
          <div class="fav-amount" *ngIf="item?.paymentAmount">
            <span class="amount">{{
              item?.paymentAmount | currency : item?.paymentCurrency : '' }}&nbsp;<em>{{ item?.paymentCurrency }}</em>
            </span>
          </div>

        </box>
      </box>
      <box class="trx-fav-repeat">
        <div> <img src="./assets/images/icons/green_repeat.svg"></div>
        <div class="repeat-fav">Repeat</div>
      </box>
    </box>

  </box>
</ng-template>
<!-- template for favourite bill payment starts -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #favBillPaymentDisplay
  [appControlTemplate]="'favBillPaymentDisplay'">
  <box *ngIf="!commonService.isDesktop()" class="transfers-trx-item">
    <box class="trx-icon">
		{{ item?.providerL }}
    </box>
   <box class="trx-secondary-info">
	<span class="trx-tag">{{ item?.mobileNumber}}</span>
  <div class="fav-amount" *ngIf="item?.paymentAmount">
    <span class="amount">{{item?.paymentAmount | currency : item?.paymentCurrency : '' }}&nbsp;<em>{{item?.paymentCurrency }}</em>
    </span>
  </div>
    </box>
 <box class="trx-details-with-repeat">
      <box class="trx-details">
        <box class="trx-primary-info">
          <span class="date">{{ item?.paymentDate | date : "dd/MM/yyyy" }}</span>
          <span class="title">{{ item?.nickname }}</span>
        </box>
      </box>
    </box>
  </box>
  <box *ngIf="commonService.isDesktop()" class="transfers-trx-item">
    <box class="trx-icon">
          {{ item?.providerL }}
    </box>
    <box class="trx-secondary-info">
      <span class="trx-tag">{{ item?.mobileNumber}}</span>
    <div class="fav-amount" *ngIf="item?.paymentAmount">
    <span class="amount">{{item?.paymentAmount | currency : item?.paymentCurrency : '' }}&nbsp;<em>{{item?.paymentCurrency }}</em>
    </span>
  </div>
</box>
    <box class="trx-details-with-repeat">
      <box class="trx-details">
        <box class="trx-primary-info">
          <span class="date">{{ item?.paymentDate | date : "dd/MM/yyyy" }}</span>
          <span class="title">{{ item?.nickname }}</span>
        </box>
      </box>
    </box>
  </box>
</ng-template>
<!-- template for favourite bill payment ends -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #chequeStatusEnquiryResult
  [appControlTemplate]="'chequeStatusEnquiryResult'">
  <ng-container *ngIf="commonService.isDesktop()">
    <box class="trx-item">
      <box class="trx-box">
        <box class="tx-icon">
          <img src="./assets/images/icons/cheque.svg" alt="cheque" />
        </box>
        <box class="trx-primary1-info">
          <span class="customer-name">{{item?.customerName}}</span>
          <span class="cheque-number">{{item?.chequeNumber}}</span>
          <div class="status">{{item?.status}}</div>
        </box>
      </box>
      <!-- <box class="trx-details">
      <span class="issue-date">{{item?.issueDate}}</span>
          <span class="customer-name">{{item?.customerName}}</span>
          <span class="cheque-number">{{item?.chequeNumber}}</span>
          <div class="status">{{item?.status}}</div>
  </box> -->
      <box class="trx-details">
        <box class="trx-secondary1-info">
          <span class="issue-date">{{
            item?.issueDate | date: "dd/MM/yyyy"
            }}</span>
          <span class="amount">{{ item?.amount| currency: item.currency:"" }}&nbsp;<em>{{
              item.currency
              }}</em> </span>
        </box>
      </box>
    </box>
  </ng-container>
  <ng-container *ngIf="commonService.isMobile()">
    <!-- <box class="trx-item">
 <box class="tx-icon">
     <img src="./assets/images/icons/cheque.svg" alt="cheque" />
 </box>
 <box class="trx-details">
     <span class="issue-date">{{item?.issueDate}}</span>
         <span class="customer-name">{{item?.customerName}}</span>
         <span class="cheque-number">{{item?.chequeNumber}}</span>
         <div class="status">{{item?.status}}</div>
 </box>
</box> -->
    <box class="trx-item">
      <box class="trx-box">
        <box class="tx-icon">
          <img src="./assets/images/icons/cheque.svg" alt="cheque" />
        </box>
        <box class="trx-primary1-info">
          <span class="customer-name">{{item?.customerName}}</span>
          <span class="cheque-number">{{item?.chequeNumber}}</span>
          <div class="status">{{item?.status}}</div>
        </box>
      </box>
      <!-- <box class="trx-details">
    <span class="issue-date">{{item?.issueDate}}</span>
        <span class="customer-name">{{item?.customerName}}</span>
        <span class="cheque-number">{{item?.chequeNumber}}</span>
        <div class="status">{{item?.status}}</div>
</box> -->
      <box class="trx-details">
        <box class="trx-secondary1-info">
          <span class="issue-date">{{
            item?.issueDate | date: "dd/MM/yyyy"
            }}</span>
          <span class="amount">{{ item?.amount | currency: item.currency:"" }}&nbsp;<em>{{
              item.currency
              }}</em></span>
        </box>
      </box>
    </box>
  </ng-container>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #allFavTransferDisplayGridTmplt
  [appControlTemplate]="'allFavTransferDisplayGridTmplt'">
  <box class="transfers-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="item?.merchantId; else noPhoto">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container>
      <ng-template #noPhoto>
        <ng-container *ngIf="item?.serviceCode == 'TRANOAT'; else noOat">
          <img [src]="'./assets/images/icons/default-profile-pic.svg'">
        </ng-container>

        <ng-template #noOat>
          {{commonService.getNameInitial(item.transfers?.beneName)}}
        </ng-template>
      </ng-template>
    </box>
    <box class="trx-details-with-repeat">
      <box class="trx-details">
        <box class="trx-primary-info">
          <span class="date">{{ item.paymentDate | date : "dd/MM/yyyy" }}</span>
          <span class="title">{{ item.serviceCode == 'TRANOAT'?'Own Account':item.transfers?.beneName }}</span>
          <!-- <span class="description">Credited to:{{item.accountNumber}}</span> -->
          <!-- <span class="description">Ref:{{ item.debitAccount }}</span> -->
        </box>
        <box class="trx-secondary-info">
          <!-- <span class="trx-tag">{{ item.serviceCode }}</span> -->
          <ng-container *ngIf="item.serviceCode == 'TRANINTBT'; else elseif1">
            <span class="trx-tag">Within Bank Transfer</span>
          </ng-container>
          <ng-template #elseif1>
            <ng-container *ngIf="item.serviceCode == 'TRANSWIFT'; else elseif2">
              <span class="trx-tag">Swift Transfer</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif2>
            <ng-container *ngIf="item.serviceCode == 'TRANIFSC'; else elseif3">
              <span class="trx-tag">IFSC Transfer</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif3>
            <ng-container *ngIf="item.serviceCode == 'TRANINTRACSEND'; else elseif4">
              <span class="trx-tag">Interac Send</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif4>
            <ng-container *ngIf="item.serviceCode == 'TRANINTRACREQUEST'; else elseif5">
              <span class="trx-tag">Interac Request</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif5>
            <ng-container *ngIf="item.serviceCode == 'TRANDOMESTIC'; else elseif6">
              <span class="trx-tag">Domestic Transfer</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif6>
            <ng-container *ngIf="item.serviceCode == 'TRANOAT'; else elseif7 ">
              <span class="trx-tag">Own Account</span>
            </ng-container>
          </ng-template>
          <ng-template #elseif7>
            <ng-container *ngIf="item.serviceCode == 'TRANINTERNATIONAL'; else else4">
              <span class="trx-tag">International Transfer</span>
            </ng-container>
          </ng-template>
          <div class="fav-amount" *ngIf="item?.paymentAmount">
            <span class="amount">
              <span class="debit-sign"></span>{{
              item.paymentAmount | currency : item.paymentCurrency : '' }}&nbsp;<em>{{ item.paymentCurrency }}</em>
            </span>
          </div>

        </box>
      </box>
      <!-- <box  class="trx-fav-repeat">
      <div> <img  src="./assets/images/icons/green_repeat.svg"></div>
      <div class="repeat-fav">Repeat</div>
    </box> -->
    </box>

  </box>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #beneList [appControlTemplate]="'beneList'">
  <ng-container *ngIf="item?.initial; else noInitial">
    <box class="bene-group-alphabhat">
      {{item?.initial}}
    </box>
  </ng-container>
  <ng-template #noInitial>
    <box class="bene-item">
      <box class="bene-detail-item">
        <box class="bene-detail-list-item">
          <box class="bene-photo">
            <ng-container *ngIf="item.image; else noPhoto">
              <img *ngIf="item.image; else noPhoto" [src]="'./assets/images/bill-payment/'+ item.image" />
            </ng-container>
            <ng-template #noPhoto>
              <box class="bene-letter-name">
                <span>{{ commonService.getNameInitial(item.beneNickName)}}</span>
                <span *ngIf="item.isFavourite==1" class="fav-star"></span>
              </box>
            </ng-template>
          </box>
          <box class="bene-details">
            <ng-container *ngIf="item.serviceCode == 'BENEINTBT'; else elseif1">
              <box class="bene-name">{{item.beneNickName}}</box>
              <box class="bank-name"></box>
              <box class="acc-number">{{item?.beneIdentifier }}</box>
            </ng-container>
            <ng-template #elseif1>
              <ng-container *ngIf="item.serviceCode == 'BENESWIFT'; else elseif2">
                <box class="bene-name">{{item.beneNickName}}</box>
                <box class="bank-name"></box>
                <box class="acc-number">{{item?.beneIdentifier }}</box>
              </ng-container>
            </ng-template>
            <ng-template #elseif2>
              <ng-container *ngIf="item.serviceCode == 'BENEIFSC'; else elseif3">
                <box class="bene-name">{{item.beneNickName}}</box>
                <box class="bank-name"></box>
                <box class="acc-number">{{item?.beneifsc?.accountNumber }}</box>
              </ng-container>
            </ng-template>
            <ng-template #elseif3>
              <ng-container *ngIf="item.serviceCode == 'BENEDOMESTIC'; else elseif4">
                <box class="bene-name">{{item.beneNickName}}</box>
                <box class="bank-name">{{item?.beneBankIdentifier }}</box>
                <box class="acc-number">{{item?.beneIdentifier }}</box>
              </ng-container>
            </ng-template>
            <ng-template #elseif4>
              <ng-container *ngIf="item.serviceCode == 'BENEINTRAC'; else elseif5">
                <box class="bene-name">{{item.beneNickName}}</box>
                <ng-container *ngIf="item?.beneintrac?.mobileNumber; else email">
                  <box class="acc-number">{{item?.beneintrac?.mobileNumber}}</box>
                </ng-container>
                <ng-template #email>
                  <box class="acc-number">{{item?.beneintrac?.email }}</box>
                </ng-template>
              </ng-container>
            </ng-template>
            <ng-template #elseif5>
              <ng-container *ngIf="item.serviceCode == 'BENEINTERNATIONAL'; else else1">
                <box class="bene-name">{{item.beneNickName}}</box>
                <box class="bank-name">{{item?.beneBankIdentifier }}</box>
                <box class="acc-number">{{item?.beneIdentifier }}</box>
              </ng-container>
            </ng-template>
          </box>
        </box>
      </box>
    </box>
  </ng-template>
</ng-template>

<!-- pfmspendcategorydisplaygrid -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #pfmspendcategorydisplaygrid
  [appControlTemplate]="'pfmspendcategorydisplaygrid'">
  <box class="pfm-spend-cat-item">
    <!-- [style.border]="'2px solid'+item?.iconTheme -->
    <box class="pfm-cat-icon" [style.border]="'2px solid'+item?.iconTheme">
      <ng-container *ngIf="item?.icon; else noPhoto">
        <!-- <img  [src]="'./assets/images/'+item.icon+'.svg'"> -->
        <box [innerHTML]="item.icon_svg"></box>
      </ng-container>
      <ng-template #noPhoto>
        <img [src]="'./assets/images/icons/default-profile-pic.svg'">
      </ng-template>
    </box>
    <box class="pfm-spend-cat-details">
      <box class="pfm-spend-cat-primary-info">
        <span class="title">{{ item.description }}</span>
        <span class="amount">
          <!-- [style.color]="item?.iconTheme" -->
          <span class="tranAmount">{{ commonService.formatAmount(item.tranTotal) }}</span>
          <span class="currency"> {{commonService.baseCurrency }}</span>
          ({{pfmMainService.percentCalculate(item.tranTotal)}}% of total exp)
        </span>
        <span class="more-info">
          <span class="description">{{item.record}} Records</span>
          <span class="see-details">See Details</span>
        </span>
      </box>
    </box>
  </box>
</ng-template>
<!-- pfmcategoryhistorydisplaygrid -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #pfmCategoryHistoryDisplayGrid
  [appControlTemplate]="'pfmCategoryHistoryDisplayGrid'">
  <box class="pfm-cat-history-item">
    <box class="pfm-cat-icon">
      <ng-container *ngIf="item?.icon; else noPhoto">
        <img [src]="'./assets/images/'+item.icon+'.svg'" />
      </ng-container>
      <ng-template #noPhoto>
        <!-- <img  [src]="'./assets/images/icons/default-profile-pic.svg'"> -->
        <img [src]="'./assets/images/spend-analyser/'+item.merchantCode.icon" />
      </ng-template>
    </box>
    <box class="pfm-cat-detail-container">
      <box class="pfm-cat-history-details">
        <box class="pfm-cat-history-primary-info">
          <span class="title">{{ item.tranDesc}}</span>
        </box>
        <span class="date">{{ item.paymentDate | date :'dd/MM/yyyy' }}</span>


      </box>
      <box class="pfm-cat-history-secondary-info">
        <box>
          <span class="pfm-category">{{ item.inventoryNumber }}</span>
        </box>
        <span class="payment-amount">
          <span class="amount">{{ commonService.formatAmount(item.tranAmount) }}
            <span class="currency"> {{item.tranCurrency}}</span>
          </span>

        </span>
      </box>
    </box>
  </box>
</ng-template>


<ng-template #budgetList [appControlTemplate]="'budgetList'" let-item let-index="index" let-first="first"
  let-last="last">

  <div class="budget-item">
    <div class="budget-detail-item">
      <div class="budget-photo">
        <ng-container *ngIf="item?.categoryCode?.icon; else noPhoto">
          <img *ngIf="item?.categoryCode?.icon; else noPhoto"
            [src]="'./assets/images/'+ item?.categoryCode?.icon+'.svg'" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="budget-letter-name">
            <span>{{ commonService.getNameInitial(item.categoryCode.description)}}</span>
          </div>
        </ng-template>
      </div>

      <div class="budget-details">
        <div class="budget-name">{{item.categoryCode?.description}}
        </div>
        <div class="budget-spend-amount">
          <div class="spend-amount">
            {{commonService.formatAmount(item.amountSpent)}}&nbsp;{{commonService.baseCurrency}}
          </div>
          <div class="total-amount">
            {{commonService.formatAmount(item.budgetAmount)}}&nbsp;{{commonService.baseCurrency}}
          </div>
        </div>
        <div class="budget-progress-bar">
          <mat-progress-bar [value]='item.percent'
            [ngClass]="{'primary': (item.percentage >= 0 && item.percentage <= 60), 'warn':(item.percentage>60 && item.percentage<=85),'danger':item.percentage>85 }">
          </mat-progress-bar>
        </div>

        <div class="budget-status">
          <div class="budget-status-name">
            <ng-container *ngIf="(item.percentage >= 0 && item.percentage <= 60); else elseif1">
              On track
            </ng-container>
            <ng-template #elseif1>
              <ng-container *ngIf="(item.percentage>60 && item.percentage <= 85); else elseif2">
                Almost finish
              </ng-container>
            </ng-template>
            <ng-template #elseif2>
              <ng-container *ngIf="(item.percentage == 100); else elseif3">
                Finish
              </ng-container>
            </ng-template>
            <ng-template #elseif3>
              <ng-container *ngIf="(item.percentage >100 ); else elseif1">
                Exceeding
              </ng-container>
            </ng-template>

          </div>
          <div class="budget-spend-percentage"
            [ngClass]="{'primary': (item.percentage >= 0 && item.percentage <= 60), 'warn':(item.percentage>65 && item.percentage<=85),'danger':item.percentage>85 }">
            {{item?.percentage}} %
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #depositRatesTmplt
  [appControlTemplate]="'depositRatesTmplt'">
  <ng-container *ngIf="commonService.isMobile()">
    <box class="deposit-rates">
      <box class="rates-sec-1">
        <box class="product-name">
          <span>{{ item.productName }}</span>
        </box>
        <box class="interest-rate">
          <span>{{ item.interestRate }}%</span>
        </box>
      </box>
      <box class="rates-sec-2">
        <box class="tenure">
          <span>{{ item.tenure }} Months</span>
        </box>
        <box class="deposit-amount">
          <span>{{ item.depositAmount | currency: item.currency:"" }}&nbsp;<em>{{
              item.currency
              }}</em>
          </span>
        </box>
      </box>
      <box class="rates-sec-3">
        <span class="deposit-type">{{ item.depositType }}</span>
      </box>
    </box>
  </ng-container>
  <ng-container *ngIf="commonService.isDesktop()">
    <box class="deposit-rates">
      <box class="deposit-types">
        <span class="deposit-type">{{ item.depositType }}</span>
      </box>
      <box class="product-name">
        <span>{{ item.productName }}</span>
      </box>
      <box class="rates-sec-2">
        <box class="tenure-rates">
          <box class="tenure">
            <span class="tenure-value">{{ item.tenure }} Months</span>
          </box> |
          <box class="interest">
            <span class="interestrate">{{ item.interestRate }}%</span>
          </box>
        </box>
        <box class="deposit-amount">
          <span>{{ item.depositAmount | currency: item.currency:"" }}&nbsp;<em>{{
              item.currency
              }}</em>
          </span>
        </box>


      </box>
    </box>
  </ng-container>
</ng-template>
<!-- pfmgoalsdisplaygrid -->
<ng-template #pfmGoalsDisplayGrid [appControlTemplate]="'pfmGoalsDisplayGrid'" let-item let-index="index"
  let-first="first" let-last="last">

  <div class="goals-item">
    <div class="goals-detail-item">
      <div class="goals-photo">
        <ng-container *ngIf="item?.icon; else noPhoto">
          <img [src]="'./assets/images/'+item.icon+'.svg'" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="goals-letter-name">
            <span>{{ commonService.getNameInitial(item.goalName)}}</span>
          </div>
        </ng-template>
      </div>

      <div class="goals-details">
        <div class="goals-name">
          <!-- {{ item.name }} -->
          {{item.goalName}}
        </div>
        <div class="goals-spend-amount">
          <div class="spend-amount">
            {{commonService.formatAmount(item.accruedAmount)}}&nbsp;{{commonService.baseCurrency}}
          </div>
          <div class="total-amount">
            {{commonService.formatAmount(item.goalAmount)}}&nbsp;{{commonService.baseCurrency}}
          </div>
        </div>
        <div class="goals-progress-bar">
          <mat-progress-bar [value]='item.percentage'
            [ngClass]="{'danger': (item.percentage >= 0 && item.percentage <= 25), 'warn':(item.percentage>25 && item.percentage<=75),'primary':item.percentage>75 }">
          </mat-progress-bar>
        </div>

        <div class="goals-status">
          <div class="goals-status-name">
            <!-- <ng-container *ngIf="(item.percentage >= 0 && item.percentage <= 25); else elseif1">
                      In progress
                    </ng-container>
                    <ng-template #elseif1>
                      <ng-container *ngIf="(item.percentage>25 && item.percentage <= 75); else elseif2">
                        On track
                      </ng-container>
                    </ng-template>
                    <ng-template #elseif2>
                      <ng-container *ngIf="(item.percentage > 75 && item.percentage < 100); else elseif3">
                       Almost finish
                      </ng-container>
                    </ng-template>
                    <ng-template #elseif3>
                      <ng-container *ngIf="item.percentage == 100; else else1">
                        Completed
                      </ng-container>
                    </ng-template> -->
            <span> {{commonService.formatAmount(item.debitAmount)}}&nbsp;{{commonService.baseCurrency}}</span>
            <span> / {{item.goalDuration}} Months</span>
          </div>
          <div class="goals-spend-percentage"
            [ngClass]="{'danger': (item.percentage >= 0 && item.percentage <= 25), 'warn':(item.percentage>25 && item.percentage<=75),'primary':item.percentage>75 }">
            {{item.percentage}} %
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #pfmCategory [appControlTemplate]="'pfmCategory'" let-item let-selectedData="selectedData"
  let-index="index" let-first="first" let-last="last" class="pfm-cat">
  <box class="pfm-category-details">
    <div class="pfm-category">
      <div class="logoWrapper">
        <div class="pfm-category-logo">
          <ng-container>
            <img [src]="'./assets/images/'+item.icon+'.svg'" />
          </ng-container>
        </div>
        <div class="category-name">{{ item.description }}</div>
      </div>
      <div>
        <span class="category-icon" [ngClass]="
              (selectedData | isRowSelected: index:'index')
                ? 'category-selected'
                : 'category-unselected'
            ">
          <span class="checkmark"></span>
        </span>
      </div>
    </div>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #serviceRequestDisplayGrid
  [appControlTemplate]="'serviceRequestDisplayGrid'">
  <div class="service-request-info">
    <div class="service-request-icon-wrapper">
      <img src="./assets/images/icons/cheque.svg" alt="" />
    </div>
    <div class="service-request-details">
      <div class="service-request-detail-row1">
        <span class="date">{{ item.requestDate | date :'dd/MM/yyyy' }}</span>
        <span class="service-request-desc">{{ item.requestTypeDesc }}</span>
        <span class="service-request-number">{{'SERVICEREQUESTLANDING.ref'| translate}} {{
          item.requestReference}}</span>
        <button type="button" class="btn-icon">
          <img src="./assets/images/icons/arrow-right.svg" alt="">
        </button>
      </div>
      <div class="service-request-detail-row2">
        <span [ngClass]="item.customerStatus?.toLowerCase()" class="service-request-status">{{
          item.customerStatus}}</span>
        <span class="amount">{{item.amount}}<em> {{item.currencyCode}}</em></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #serviceRequestStagesDisplayGrid
  [appControlTemplate]="'serviceRequestStagesDisplayGrid'">
  <div class="service-request-status-list-item">
    <div class="service-request-info">
      <div class="service-request-details">
        <div class="service-request-detail-row1">
          <span class="date">{{ item.dateTime }}</span>
          <span class="service-request-desc">{{ item.taskName }}</span>

        </div>
        <div class="service-request-detail-row2">
          <span [ngClass]="item.stage?.toLowerCase()" class="service-request-status">{{ item.stage}}</span>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<!-- cashflowFundCategoryDisplayGrid -->
<ng-template let-item let-index="index" let-first="first" let-last="last" #fundcategorydisplaygrid
  [appControlTemplate]="'fundcategorydisplaygrid'">
  <box class="fund-cat-item">
    <box class="fund-cat-icon" [style.border]="'2px solid'+item?.iconTheme">
      <ng-container *ngIf="item?.icon; else noPhoto">
        <box [innerHTML]="item?.icon_svg"></box>
      </ng-container>
      <ng-template #noPhoto>
        {{commonService.getNameInitial(item?.frequencyDesc)}}
        <!-- <img  [src]="'./assets/images/icons/default-profile-pic.svg'"> -->
      </ng-template>
    </box>
    <box class="fund-cat-details">
      <box class="fund-cat-primary-info">
        <span class="title">{{ item?.frequencyDesc }}</span>
        <span class="amount">
          <span class="tranAmount">{{ commonService.formatAmount(item?.tranTotal) }}</span>
          <span class="currency"> {{commonService.baseCurrency }}</span>
        </span>
        <span class="more-info">
          <span class="description">{{item?.record}} Records</span>
          <span class="see-details">See Details</span>
        </span>
      </box>
    </box>
  </box>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #pfmfundshistorydisplaygrid
  [appControlTemplate]="'pfmfundshistorydisplaygrid'">
  <box class="fund-cat-history-item">
    <box class="fund-cat-icon">
      <ng-container *ngIf="item?.icon; else noPhoto">
        <img [src]="'./assets/images/'+item.icon+'.svg'" />
      </ng-container>
      <ng-template #noPhoto>
        {{commonService.getNameInitial(item?.categoryName)}}
      </ng-template>
    </box>
    <box class="fund-cat-history-details">
      <box class="fund-cat-history-primary-info">
        <span class="title">{{ item.categoryName}}</span>
        <span class="date">{{ item.startDate | date :'dd/MM/yyyy' }}</span>

      </box>
      <box class="fund-cat-history-secondary-info">
        <span class="fund-category">{{ item.inventoryNumber }}</span>
        <span class="payment-amount">
          <span class="amount">{{ commonService.formatAmount(item.fundAmount) }}
            <span class="currency"> {{commonService.baseCurrency}}</span>
          </span>

        </span>
      </box>
    </box>
  </box>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #pfmcashflowactivefundsdisplaygrid
  [appControlTemplate]="'pfmcashflowactivefundsdisplaygrid'">
  <box class="fund-cat-history-item">
    <box class="fund-cat-icon">
      <ng-container *ngIf="item?.icon; else noPhoto">
        <img [src]="'./assets/images/'+item.icon+'.svg'" />
      </ng-container>
      <ng-template #noPhoto>
        {{commonService.getNameInitial(item?.categoryName)}}
      </ng-template>
    </box>
    <box class="fund-cat-history-details">
      <box class="fund-cat-history-primary-info">
        <box class="fund-cat-history-title">
          <span class="title">{{ item.categoryName}}</span>
        </box>
        <span class="date">{{ item.startDate | date :'dd/MM/yyyy' }}</span>
      </box>
      <box class="fund-cat-history-secondary-info">
        <box class="fund-category-desc">
          <span class="fund-category">{{ item.frequencyDesc }}</span>
        </box>
        <span class="payment-amount">
          <span class="amount">{{ commonService.formatAmount(item.fundAmount) }}
            <span class="currency"> {{commonService.baseCurrency}}</span>
          </span>

        </span>
      </box>
    </box>
  </box>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #pfmcashflowexcludefundsdisplaygrid
  [appControlTemplate]="'pfmcashflowexcludefundsdisplaygrid'">
  <box class="fund-cat-history-item">
    <box class="fund-cat-icon">
      <ng-container *ngIf="item?.icon; else noPhoto">
        <img [src]="'./assets/images/'+item.icon+'.svg'" />
      </ng-container>
      <ng-template #noPhoto>
        {{commonService.getNameInitial(item?.categoryName)}}
      </ng-template>
    </box>
    <box class="fund-cat-history-details">
      <box class="fund-cat-history-primary-info">
        <span class="title">{{ item.categoryName}}</span>
        <span class="date">{{ item.startDate | date :'dd/MM/yyyy' }}</span>
      </box>
      <box class="fund-cat-history-secondary-info">
        <box class="fund-category-desc">
          <span class="fund-category">{{ item.frequencyDesc }}</span>
        </box>
        <span class="payment-amount">
          <span class="amount">{{ commonService.formatAmount(item.fundAmount) }}
            <span class="currency"> {{commonService.baseCurrency}}</span>
          </span>

        </span>
      </box>
    </box>
  </box>
</ng-template>


<ng-template let-item let-index="index" let-first="first" let-last="last" #staticdocumentDisplayTmplt
  [appControlTemplate]="'staticdocumentDisplayTmplt'">
  <box class="static-doc-item">
    <div class="static-doc-icon">
      <ng-container *ngIf="item?.docextensiontypes[0].icon;">
        <!-- <img [src]="'./assets/images/documents/adobe.svg'" /> -->
        <img *ngIf="item?.docextensiontypes[0].icon; "
          [src]="'./assets/images/documents/'+ item?.docextensiontypes[0].icon" />

      </ng-container>
    </div>
    <div class="static-doc-details">
      <div class="static-doc-primary-info">
        <span class="title">{{ item.fileName }}</span>
      </div>
      <div class="static-doc-secondary-info">
        <span class="expiryDate">{{ item.expiryDate}}</span>


      </div>

    </div>
    <div class="static-doc-icon">
      <ng-container>
        <!-- <img [src]="'./assets/images/documents/adobe.svg'" /> -->
        <img class="download" src="./assets/images/trxicons/file-download.svg" alt="download" />

      </ng-container>
    </div>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #mailboxrequestsdisplaygrid
  [appControlTemplate]="'mailboxrequestsdisplaygrid'">
  <box class="mailbox-requests-item">
    <box class="mailbox-requests-details">
      <box class="mailbox-requests-primary-info">
        <span class="date">{{item?.updatedOn  | dateFormatter: "dd/mm/yyyy" }}</span>
        <span class="message"><span class="message-text">{{item.subject}}</span><span *ngIf="(item.isNew=='1')"
            class="new-mail">New </span></span>
        <span class="sub-category"><span class="sub-category-name">{{item.categoryCode}}</span><span><span
              class="separate">|</span></span><span class="sub-category-invetoryNo">Ref #:
            {{item.inventoryNumber}}</span></span>
        <div class="mail-status">
          <ng-container *ngIf="(item.caseStatus=='1'); else elseif1">
            <span class="open"> Open </span>
          </ng-container>
          <ng-template #elseif1>
            <ng-container *ngIf="(item.caseStatus=='2'); else elseif2">
              <span class="in-progress"> In-progress </span>
            </ng-container>
          </ng-template>
          <ng-template #elseif2>
            <ng-container *ngIf="(item.caseStatus=='3'); else elseif3">
              <span class="closed"> Resolved </span>
            </ng-container>
          </ng-template>
	     <ng-template #elseif3>
            <ng-container *ngIf="(item.caseStatus=='4'); else else3">
              <span class="closed"> Re-open </span>
            </ng-container>
          </ng-template>

        </div>


      </box>
      <box class="mailbox-requests-secondary-info">
        <div class="arrow-right">
          <svg xmlns="http://www.w3.org/2000/svg" width="8.414" height="14.989" viewBox="0 0 8.414 14.989">
            <g id="arrow-right" transform="translate(1.414 1.414)">
              <path id="Shape" d="M0,0,6,6.08,0,12.16" transform="translate(0)" fill="none" stroke="#004A63"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
            </g>
          </svg>

        </div>
      </box>
    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" let-selectedData="selectedData"
  #emiCalculationDisplayGrid [appControlTemplate]="'emiCalculationDisplayGrid'">
  <box class="emi-calculation first-item-head">
    <div [ngClass]="
    (selectedData | isRowSelected: index:'index')
      ? 'emi-selected'
      : 'emi-unselected'
  ">
      <box class="year-list">
        {{item?.year}}
        <img src="./assets/images/right-arrow-active.svg" />
      </box>
      <div class="title">
        <div class="mon"><span>Months</span></div>
        <div class="principal"><span>Principal</span></div>
        <div class="interest"><span>Interest</span></div>
        <div class="bal"><span>Balance</span></div>
      </div>
      <div class="list-item-content">
        <div class="list-item">
          <ng-container *ngFor="let element of item.loanDetailList;">
            <!-- <div id="yearlist_{{ i }}_{{ cardIndex }}"> -->
            <div class="loan-detail">
              <box class="loan-item-tenure">
                {{element?.tenure}}
              </box>
              <box class="loan-item-principal">
                {{commonService.formatAmount(element?.principal)}}
              </box>
              <box class="loan-item-interest">
                {{commonService.formatAmount(element?.interest)}}
              </box>
              <box class="loan-item-balance">
                {{commonService.formatAmount(element?.balance)}}
              </box>
            </div>
            <!-- </div> -->
          </ng-container>
        </div>
      </div>
    </div>
  </box>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #mailboxrequestdetailsdisplaygrid
  [appControlTemplate]="'mailboxrequestdetailsdisplaygrid'">
  <ng-container *ngIf="(item?.label=='date'); else elseif1">
    <box class="show-date">
      <span>{{item?.date | dateFormatter: "yyyy-mm-dd"}}</span>
    </box>
  </ng-container>
  <ng-template #elseif1>
    <!-- <box class="mailbox-requests-item" [ngClass]="[item.index%2==0 ?'flex-right':'flex-left']"> -->
    <!-- {{userService.customerCode}} -- {{item.createdBy}} -->
    <box *ngIf="!item?.label" class="mailbox-requests-item"
      [ngClass]="[userService.customerCode == item.createdBy ? 'flex-right':'flex-left']">
      <box class="mailbox-requests-details">

        <box class="mailbox-requests-primary-info">
          <box class="round-initial">
            <ng-container *ngIf="(userService.customerCode == item.createdBy); else elseif1">

              <img [src]="userService.getUserProfileImage()">
            </ng-container>
            <ng-template #elseif1>
              <img [src]="'./assets/images/icons/default-profile-pic.svg'">
            </ng-template>

          </box>
          <input class="focus-input" />
          <span class="message">{{item.comments}}</span>
          <span class="category-attachment-list"  *ngIf="item?.attachment">
            <!-- <ng-container *ngFor="let file of item?.casecmtattach;">
              <span class="category" (click)="downloadFile(file)">{{file?.fileName}}</span>
            </ng-container> -->
            <span class="category" (click)="downloadFile(item?.attachment)">{{item?.fileName?item?.fileName:item?.attachment}}</span>
          </span>
        </box>
        <box class="mailbox-requests-secondary-info">
        <span class="date">{{item.updatedOn}}</span>
        </box>
      </box>
    </box>
  </ng-template>
</ng-template>
<ng-template let-item let-index="index" let-first="first" let-last="last" #scheduleTransferDisplyGridTmplt
  [appControlTemplate]="'scheduleTransferDisplyGridTmplt'">
  <box class="transfers-trx-item">
    <box class="trx-icon">
      <ng-container *ngIf="item.merchantId; else elseif11">
        <img *ngIf="item.icon; else noPhoto" [src]="'./assets/images/trxicons/'+item.icon" />
      </ng-container>
      <ng-template #elseif11>
        <ng-container *ngIf="item.serviceCode == 'SCHINTBT'; else elseif12">
          <img [src]="'./assets/images/transfers/Within Bank Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif12>
        <ng-container *ngIf="item.serviceCode == 'SCHSWIFT'; else elseif13">
          <img [src]="'./assets/images/transfers/international-transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif13>
        <ng-container *ngIf="item.serviceCode == 'SCHDOM'; else elseif14">
          <img [src]="'./assets/images/transfers/EFT Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif14>
        <ng-container *ngIf="item.serviceCode == 'SCHINTRACSEND'; else elseif15">
          <img [src]="'./assets/images/transfers/Send E-Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif15>
        <ng-container *ngIf="item.serviceCode == 'SCHINTRACREQUEST'; else elseif16">
          <img [src]="'./assets/images/transfers/Receive E-Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #elseif16>
        <ng-container *ngIf="item.serviceCode == 'SCHOAT'; else noPhoto">
          <img [src]="'./assets/images/transfers/Own Account Transfer.svg'">
        </ng-container>
      </ng-template>
      <ng-template #noPhoto>
        <img [src]="'./assets/images/icons/default-profile-pic.svg'">
        <!-- {{ item.serviceCode?.charAt(0).toUpperCase() }} -->
      </ng-template>
    </box>
    <box class="trx-details">
      <box class="trx-primary-info">

        <span class="title">{{ item.serviceCode=="SCHOAT"?"Own Account":item.beneName }}</span>
        <!-- <span class="description">Credited to:{{item.creditAcc}}</span> -->
        <span class="description">Ref# : {{ item.scheduleId.substring(item.scheduleId.length-6) }}</span>
        <span class="date">Payment Due Date {{ item.nextPaymentDate | date :'dd/MM/yyyy' }}</span>
      </box>
      <box class="trx-secondary-info">
        <ng-container *ngIf="item.serviceCode == 'SCHINTBT'; else elseif1">
          <div class="trx-tag-container">
            <span class="trx-tag">WITHIN BANK</span>
            <span class="trx-tag">{{item.scheduleType=='3'?'RECURRING':'PAY LATER'}}</span>
          </div>
      
        </ng-container>
        <ng-template #elseif1>
          <ng-container *ngIf="item.serviceCode == 'SCHSWIFT'; else elseif2">
            <div class="trx-tag-container">
              <span class="trx-tag">INTERNATIONAL</span>
              <span class="trx-tag">{{item.scheduleType=='3'?'RECURRING':'PAY LATER'}}</span>
            </div>
      
          </ng-container>
        </ng-template>
        <ng-template #elseif2>
          <ng-container *ngIf="item.serviceCode == 'SCHIFSC'; else elseif3">
            <div class="trx-tag-container">
              <span class="trx-tag">BANK TO BANK TRANSFER</span>
              <span class="trx-tag">{{item.scheduleType=='3'?'RECURRING':'PAY LATER'}}</span>
            </div>
      
          </ng-container>
        </ng-template>
        <ng-template #elseif3>
          <ng-container *ngIf="item.serviceCode == 'SCHINTRACSEND'; else elseif4">
            <div class="trx-tag-container">
              <span class="trx-tag">INTERAC SEND</span>
              <span class="trx-tag">{{item.scheduleType=='3'?'RECURRING':'PAY LATER'}}</span>
            </div>
      
          </ng-container>
        </ng-template>
        <ng-template #elseif4>
          <ng-container *ngIf="item.serviceCode == 'SCHINTRACREQUEST'; else elseif5">
            <div class="trx-tag-container">
              <span class="trx-tag">INTERAC REQUEST</span>
              <span class="trx-tag">{{item.scheduleType=='3'?'RECURRING':'PAY LATER'}}</span>
            </div>
      
          </ng-container>
        </ng-template>
        <ng-template #elseif5>
          <ng-container *ngIf="item.serviceCode == 'SCHDOM'; else elseif6">
            <div class="trx-tag-container">
              <span class="trx-tag">DOMESTIC</span>
              <span class="trx-tag">{{item.scheduleType=='3'?'RECURRING':'PAY LATER'}}</span>
              <span class="trx-tag">{{item.frequency.toUpperCase() }}</span>
            </div>
      
          </ng-container>
        </ng-template>
        <ng-template #elseif6>
          <ng-container *ngIf="item.serviceCode == 'SCHOAT'; else else4">
            <div class="trx-tag-container">
              <span class="trx-tag">OWN ACCOUNT</span>
              <span class="trx-tag">{{item.scheduleType=='3'?'RECURRING':'PAY LATER'}}</span>
            </div>
      
          </ng-container>
        </ng-template>
        <span class="amount">
          <span class="debit-sign"></span>{{
          item.paymentAmount | currency : item.paymentCurrency : '' }}
          &nbsp;<em>{{item.paymentCurrency }}</em>
        </span>
      </box>
    </box>
  </box>
</ng-template>

<ng-template let-item let-index="index" let-first="first" let-last="last" #recentRechargeDisplayGridTmplt
[appControlTemplate]="'recentRechargeDisplayGridTmplt'">
  <div class="rechargeInfo transfers-trx-item">
    <span class="histicon">
      <svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.0927 0H2.036C1.49622 0.0006368 0.97872 0.215348 0.597034 0.597034C0.215348 0.97872 0.0006368 1.49621 0 2.036V21.964C0.0006368 22.5038 0.215348 23.0213 0.597034 23.403C0.97872 23.7847 1.49622 23.9994 2.036 24H12.0927C12.6325 23.9994 13.15 23.7847 13.5317 23.403C13.9134 23.0213 14.1281 22.5038 14.1287 21.964V2.036C14.1281 1.49621 13.9134 0.97872 13.5317 0.597034C13.15 0.215348 12.6325 0.0006368 12.0927 0ZM1.11055 4.072H13.0182V19.1876H1.11055V4.072ZM2.036 1.11055H12.0927C12.3381 1.11084 12.5733 1.20844 12.7468 1.38193C12.9203 1.55542 13.0179 1.79064 13.0182 2.036V2.96146H1.11055V2.036C1.11084 1.79064 1.20844 1.55542 1.38193 1.38193C1.55542 1.20844 1.79064 1.11084 2.036 1.11055ZM12.0927 22.8895H2.036C1.79064 22.8892 1.55542 22.7916 1.38193 22.6181C1.20844 22.4446 1.11084 22.2094 1.11055 21.964V20.2982H13.0182V21.964C13.0179 22.2094 12.9203 22.4446 12.7468 22.6181C12.5733 22.7916 12.3381 22.8892 12.0927 22.8895Z" fill="#004A63"/>
        <path d="M7.65049 21.0386H6.47812C6.33086 21.0386 6.18962 21.0971 6.08549 21.2012C5.98135 21.3053 5.92285 21.4466 5.92285 21.5938C5.92285 21.7411 5.98135 21.8824 6.08549 21.9865C6.18962 22.0906 6.33086 22.1491 6.47812 22.1491H7.65049C7.79776 22.1491 7.93899 22.0906 8.04313 21.9865C8.14726 21.8824 8.20576 21.7411 8.20576 21.5938C8.20576 21.4466 8.14726 21.3053 8.04313 21.2012C7.93899 21.0971 7.79776 21.0386 7.65049 21.0386Z" fill="#004A63"/>
      </svg>        
    </span>
    <span class="topupprimrybx">
      <span class="message topup_nickname">{{item.nickname}}</span>
      <span class="trx-tag trx-tag-status" [class.success] = "item.status === 'S'">{{item.status=='S'?'SUCCESS': item.status == 'P' ? 'PENDING' : 'FAILED'}}</span>

    </span>  
    <span class="topup_mob_service">
      <span class="message topup_provider"> {{item.provider}}</span>
      <span class="message topup_number">  {{item.mobileNumber}}</span>
    </span>
    <span class="rechargebtn">
      <!-- <button type="button" class="btn-icon">Recharge</button> -->
      <span class="message topup_date">{{item?.createdOn |  dateFormatter: "dd/mm/yyyy" }}</span>
      <!-- <span class="message topup_amount"><span class="cur">PGK -</span>{{item.amount}}.00</span>    -->
       <span class="message topup_amount"><span class="cur">PGK -</span>
      {{item.amount | currency : 'PGK' : '' }}
      </span>  
      
      <!-- <span class="amount">
          {{
          item.paymentAmount | currency : item.paymentCurrency : '' }}
          &nbsp;<em>{{item.paymentCurrency }}</em>
        </span> -->
      
    </span>
  </div>
  
</ng-template>

